import React from 'react';
import classnames from 'classnames';
import classes from './giveaway-landing-subtitle.scss';
export const GiveawayLandingSubtitle = ({
  children,
  className,
  withBottomIndent = true
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.title, {
      [classes.indent]: withBottomIndent
    }, className)
  }, children);
};